import { Component, OnInit } from '@angular/core';
import { Subject } from 'rxjs';
import { MDBModalRef } from 'angular-bootstrap-md';
import { FormBuilder, Validators } from '@angular/forms';

@Component({
  selector: 'app-filter-dialog',
  templateUrl: './filter-dialog.component.html',
  styleUrls: ['./filter-dialog.component.scss']
})
export class FilterDialogComponent implements OnInit {

  action: Subject<any> = new Subject();
  data: any;
  resetDiscount: any;
  filterDiscount: any;
  startDiscount: any;
  endDiscount: any;
  resetPrice: any;
  filterPrice: any;
  startPrice: number ;
  endPrice: number;

  // selectedSorting: any = 'desc';
  filtersTypeArray: any
  constructor(public modalRef: MDBModalRef,public fb: FormBuilder) {
    
   }
  registrationForm = this.fb.group({
    selectedSorting: ['', [Validators.required]]
  })
  ngOnInit() {
  }
  
 
  trackByName(index, item) {
    return item;
  }

  toggleAccordian(event, index) {
    console.log('event', event)
    var element = event.target;
    element.classList.toggle('active');

    var panel = element.nextElementSibling;
    if (panel.style.maxHeight) {
      panel.style.maxHeight = null;
    } else {
      panel.style.maxHeight = 100 + 'px';
      panel.style.overflow = 'auto'
    }

  }
  applyFilters() {
    console.log(this.data);  
    sessionStorage.setItem('Filter', this.data); 
    this.action.next('data');
  }

  onClose() {
    this.action.next('yes');
  }
}
